<template>
  <div class="panel" id="dim-panel">
    <app-header/>
    <slot></slot>
  </div>
</template>

<script>
import AppHeader from '@/components/AppHeader/AppHeader'

export default {
  name: 'my-panel',
  components: {
    AppHeader
  }
}
</script>



// WEBPACK FOOTER //
// MyPanel.vue?57a0e87d